export default {
  state: {
    inventoryTrend: {
      warehouseName: '',
      stockAgeScope: ''
    }
  },
  getters: {
    getInventoryTrend(state){
      return state.inventoryTrend;
    }
  },
  mutations: {
    setInventoryTrend(state, param){
      state.inventoryTrend = param;
    },
    setWarehouseName(state, param){
      state.inventoryTrend.warehouseName = param;
    },
    setStockAgeScope(state, param){
      state.inventoryTrend.stockAgeScope = param;
    }
  },
  actions: {
    setInventoryTrend(context, param){
      context.commit('setInventoryTrend', param);
    },
    setWarehouseName(context, param){
      context.commit('setWarehouseName', param);
    },
    setStockAgeScope(context, param){
      context.commit('setStockAgeScope', param);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/inventory-trend.js